const navValues = {
    home: "",
    current: "current",
    forecast24: "forecast24",
    NextDays: "NextDays",
    External: "External",
    now: "now"
};

export default navValues;